import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { LeadSection } from '../components/LeadSection';
import { AgitationSection } from '../components/AgitationSection';
import { AvatarSection } from '../components/AvatarSection';
import { FailedSolutionsSection } from '../components/FailedSolutionsSection';
import { MechanismSection } from '../components/MechanismSection';
import { ProductSection } from '../components/ProductSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { AnimatedWaves } from '../components/AnimatedWaves';
import { RecentPurchasePopup } from '../components/RecentPurchasePopup';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-dark-bg text-text-primary relative selection:bg-gold/30 selection:text-gold overflow-hidden" data-id="element-289">
      <div className="bg-waves" data-id="element-290"></div>
      <AnimatedWaves data-id="element-291" />
      <Navbar data-id="element-292" />
      <main className="relative z-10" data-id="element-293">
        <HeroSection data-id="element-294" />
        <LeadSection data-id="element-295" />
        <AgitationSection data-id="element-296" />
        <AvatarSection data-id="element-297" />
        <FailedSolutionsSection data-id="element-298" />
        <MechanismSection data-id="element-299" />
        <ProductSection data-id="element-300" />
        <TestimonialsSection data-id="element-301" />
        <ForWhomSection data-id="element-302" />
        <PricingSection data-id="element-303" />
        <FAQSection data-id="element-304" />
      </main>
      <Footer data-id="element-305" />
      <RecentPurchasePopup data-id="element-306" />
    </div>;
}